import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronWideOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M.85 9.39 8 5.31l7.15 4.08" stroke="currentColor" strokeWidth={1.4} />
        </g>
    </svg>
));
ChevronWideOutlinedSize16Glyph.displayName = 'ChevronWideOutlinedSize16Glyph';
